import Swal from 'sweetalert2';


export function typeError(errormsg) {
    Swal.fire("Error!", errormsg, "error");
}

// Info Type Alert
export function typeInfo(msg) {
  Swal.fire("Information",msg, "info");
}


export function stypeError() {
Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      )
    }
  });
}
